import React from 'react';
import { LoadingIcon, XIcon, YellowWarningIcon } from 'assests/GmsIcons';


type ConfirmDialogProps = {
    title: string;
    message: string;
    confirmText: string;
    cancelText: string;
    ternaryText: string;
    onClose: () => void;
    onConfirm: () => void;
    ternaryMethod: () => void;
    saveInProgress?: boolean;
}

const ConfirmModal = ({ title, message, confirmText, cancelText, ternaryText, onClose, onConfirm, ternaryMethod, saveInProgress }: ConfirmDialogProps) => {

    return (
        <div className={` tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-bg-opacity-50 tw-z-50`}>
            <div className={`tw-bg-white tw-rounded tw-shadow-md tw-w-[378px]  tw-h-[220px]`}>
                <div className='tw-flex tw-justify-between tw-items-center'>
                    <h2 className={`tw-text-sm tw-font-semibold tw-my-3 tw-px-3 `}>{title}</h2>
                    <button className='tw-mr-2' onClick={onClose}><XIcon /></button>
                </div>
                <div className="tw-w-[378px] tw-h-[0px] tw-border tw-border-[#dfe0e6]"></div>
                <div className="tw-h-[60px] tw-m-4 tw-p-2.5 tw-bg-[#fffae6] tw-rounded tw-border tw-border-[#ffc400] tw-justify-start tw-items-center tw-gap-2.5 tw-inline-flex">
                    <YellowWarningIcon />
                    <div className="tw-w-[292px] tw-text-black tw-text-sm  tw-leading-tight">{message}</div>
                </div>

                <div className={`tw-px-3 tw-mt-6 tw-flex tw-gap-2 tw-justify-end`}>
                    <button className="tw-h-auto tw-w-auto tw-px-1 tw-py-2 tw-bg-white tw-justify-center tw-items-center tw-gap-2.5  tw-rounded-md tw-inline-flex tw-text-[#bf2600] hover:tw-bg-gray-100" onClick={ternaryMethod}>
                        {ternaryText}
                    </button>
                    <button onClick={onClose} className='button-outlined hover:tw-bg-gray-100 tw-flex' >{cancelText}</button>
                    <button className="tw-h-auto tw-w-auto tw-px-2 tw-py-2 tw-justify-center tw-items-center tw-gap-2.5  tw-rounded-md tw-inline-flex tw-text-white hover:tw-bg-[#3024d2] tw-bg-[#0747a6]"
                        onClick={onConfirm} disabled={saveInProgress}>
                        {saveInProgress && <LoadingIcon />} {saveInProgress ? "Saving" : confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ConfirmModal;